var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-crud-form',{ref:"form",attrs:{"mode":_vm.mode,"backend":_vm.backend},on:{"cancel":function (data) { return _vm.$emit('cancel', data); },"save":function (data) { return _vm.$emit('save', data); }}})}
var staticRenderFns = []

export { render, staticRenderFns }